import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';


interface ProcessStep {
  id: number;
  stepNumber: number;
  icon: string;
  title: string;
  description: string;
}

interface ProcessSectionProps {
  steps: ProcessStep[];
}

const ProcessSection = ({ steps }: ProcessSectionProps) => {
  const { t } = useLanguage();

  return (
    <section className="py-20 lg:py-28 bg-gradient-luxury text-primary-foreground relative overflow-hidden">
      <div className="relative mx-auto max-w-content px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight">
            {t('home.process.title')}
          </h2>
          <p className="font-body text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            {t('home.process.subtitle')}
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16 relative">
          {/* Connection Lines (Desktop Only) */}
          <div className="hidden md:block absolute top-32 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-accent/30 to-transparent" style={{ width: 'calc(100% - 160px)', left: '80px' }} />

          {steps.map((step, index) =>
          <div key={step.id} className="relative">
              {/* Step Card */}
              <div className="bg-secondary rounded-2xl p-10 shadow-luxury-sm border border-border/50 text-center relative z-10 hover:shadow-luxury-md transition-luxury">
                {/* Step Number Badge */}
                <div className="w-20 h-20 bg-gradient-gold rounded-full flex items-center justify-center mx-auto mb-8 shadow-luxury-md relative z-20 border-4 border-white">
                  <span className="font-heading text-3xl font-bold text-accent-foreground">
                    {step.stepNumber}
                  </span>
                </div>

                {/* Icon */}
                <div className="w-24 h-24 bg-white rounded-xl flex items-center justify-center mx-auto mb-8 shadow-luxury-sm">
                  <Icon
                  name={step.icon as any}
                  size={44}
                  className="text-primary"
                  variant="outline" />

                </div>

                {/* Title */}
                <h3 className="font-heading text-2xl font-semibold text-primary mb-4 tracking-tight">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="font-body text-base text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </div>

              {/* Arrow (Mobile Only) */}
              {index < steps.length - 1 &&
            <div className="md:hidden flex justify-center my-6">
                  <Icon
                name="ChevronDownIcon"
                size={32}
                className="text-accent"
                variant="solid" />

                </div>
            }
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default ProcessSection;